// extracted by mini-css-extract-plugin
export default {"confirm-email-container":"ConfirmEmail_confirm-email-container__K8kWr","icon":"ConfirmEmail_icon__1Uqkm","message":"ConfirmEmail_message__8yhx5"};